import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const { iframeInstabugMetricsTrackerURL } = config.powerBiSettings;

function TicketingMetrics() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      default:
        return iframeInstabugMetricsTrackerURL;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default TicketingMetrics;
